import { Record as record } from 'immutable';
import moment from 'moment';

import { construct, fields } from '../../../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../../helpers/Records';
import { translate as t } from '../../../lib/I18n';

const fieldSchema = {
    months: [ fields.number ],
    days: [ fields.number ]
};

class TimePeriod extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(TimePeriod, json, getResolvers(fieldSchema));
    }

    toString () {
        return this.months > 0 ?
            t('account.orders.refund.itso.timePeriod', { m: this.months, d: this.days }) :
            t('account.orders.refund.itso.timePeriod.noMonth', { d: this.days });
    }

    toDuration () {
        return moment.duration({
            months: this.months,
            days: this.days
        });
    }
}

export default TimePeriod;
